import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class PayrollService {

    constructor(private api: ApiService) { }

    listPayrolls(employeeId: number | string, params: any = {}): Observable<any> {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return this.api.get(`hr/employee/${employeeId}/payroll/list${queryString ? '?' + queryString : ''}`);
    }

    getPayrollById(id: number | string): Observable<any> {
        return this.api.get(`hr/payroll/show/${id}`);
    }

    listReceipts(params: any = {}): Observable<any> {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return this.api.get(`hr/payroll-receipts${queryString ? '?' + queryString : ''}`);
    }

    stampBulk(params: any = {}): Observable<any> {
        return this.api.post('hr/payroll-receipts/stamp-bulk', params);
    }

    /** Paso 1 del asistente de timbrado masivo: recibos disponibles para elegir. */
    readyToStamp(params: any = {}): Observable<any> {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return this.api.get(`hr/payroll-receipts/ready-to-stamp${queryString ? '?' + queryString : ''}`);
    }

    /** Paso 2: valida los datos fiscales de los colaboradores elegidos en el paso 1. */
    validateSelection(payrollIds: Array<number | string>): Observable<any> {
        return this.api.post('hr/payroll-receipts/validate-selection', { payroll_ids: payrollIds });
    }

    /** Paso 3->4: crea el lote de timbrado con los recibos elegidos. */
    createStampBatch(payrollIds: Array<number | string>): Observable<any> {
        return this.api.post('hr/payroll-receipts/stamp-batches', { payroll_ids: payrollIds });
    }

    /** Paso 4: avanza el lote un fragmento y devuelve el estado completo. */
    processStampBatchChunk(batchId: number | string): Observable<any> {
        return this.api.post(`hr/payroll-receipts/stamp-batches/${batchId}/process-next`, {});
    }

    /**
     * Descarga el PDF del recibo como blob (incluye el header Authorization,
     * a diferencia de un <a href> directo al backend) y lo entrega al navegador
     * mediante un enlace temporal, siguiendo el mismo patrón usado en
     * ExpenseService.downloadPdf / downloadXls.
     */
    downloadPdf(id: number | string): Observable<Blob> {
        return this.api.getBlob(`hr/payroll/${id}/pdf`);
    }
}
